import React from "react"
import PropTypes from "prop-types"

import RouterLink from "@irati/ui/src/Link/RouterLink"
import {FormattedMessage} from "@irati/utils/lang"
import {injectRouteWithQuery} from "@irati/utils/helpers/routing"
import id from "@irati/utils/id"

const EditLink = ({url, params, queryParams, hash, contentId, ...props}) => {
  const idNamespace = id("EditLink", props)
  const route = injectRouteWithQuery(url, {hash})
  return (
    <RouterLink id={idNamespace} to={route} plain>
      <FormattedMessage id={contentId} />
    </RouterLink>
  )
}
EditLink.propTypes = {
  url: PropTypes.string.isRequired,
  params: PropTypes.object,
  queryParams: PropTypes.object,
  hash: PropTypes.string,
  contentId: PropTypes.string.isRequired
}
EditLink.defaultProps = {
  params: {},
  queryParams: {},
  hash: ""
}
export default EditLink
